import { TShowFeature } from '@feat-auth/types';
import { createContext } from 'react';

type FeatureContextProps = {
  showFeature: TShowFeature;
};

const initAuthContextPropsState = {
  showFeature: () => false,
};

const FeatureContext = createContext<FeatureContextProps>(initAuthContextPropsState);
FeatureContext.displayName = 'Features Context';

export default FeatureContext;
